// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__106Xa","footer":"ModalError_footer__1vks0"};